import dayjs from 'dayjs';

import type { DashboardDateRange } from '../types/dashboard.types';

export function getThisWeekRange(): DashboardDateRange {
  const start = dayjs().startOf('week');
  const end = dayjs().endOf('week');
  return {
    from: start.format('YYYY-MM-DD'),
    to: end.format('YYYY-MM-DD'),
    label: 'This week',
  };
}

export function getLastWeekRange(): DashboardDateRange {
  const start = dayjs().subtract(1, 'week').startOf('week');
  const end = dayjs().subtract(1, 'week').endOf('week');
  return {
    from: start.format('YYYY-MM-DD'),
    to: end.format('YYYY-MM-DD'),
    label: 'Last week',
  };
}

export function getThisMonthRange(): DashboardDateRange {
  const start = dayjs().startOf('month');
  const end = dayjs().endOf('month');
  return {
    from: start.format('YYYY-MM-DD'),
    to: end.format('YYYY-MM-DD'),
    label: 'This month',
  };
}

export const DATE_RANGE_PRESETS: DashboardDateRange[] = [
  getThisWeekRange(),
  getLastWeekRange(),
  getThisMonthRange(),
];

/** Format seconds as "Xh Ym" for stat cards */
export function formatHoursMinutes(secs: number): string {
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}

/** Format cents as "$X.XX" */
export function formatCents(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

/** Billability percentage */
export function billabilityPercent(totalSecs: number, billableSecs: number): number {
  if (totalSecs === 0) return 0;
  return Math.round((billableSecs / totalSecs) * 100);
}
